import { APP_INITIALIZER, ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';

import { routes } from './app.routes';
import { bearerTokenInterceptor } from './core/bearer-token.interceptor';
import { AuthTokenService } from './core/auth-token.service';

function initializeAuth(authTokenService: AuthTokenService): () => Promise<void> {
  return () => authTokenService.initialize();
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideHttpClient(withInterceptors([bearerTokenInterceptor])),
    {
      provide: APP_INITIALIZER,
      useFactory: initializeAuth,
      deps: [AuthTokenService],
      multi: true
    },
    provideRouter(routes)
  ]
};
